class PurchaseOptions extends HTMLElement {
  constructor() {
    super();
    this.selectors = {
      product: "[data-main-product]",
      sellingPlanGroups: "[data-selling-plan-group-selector]",
      sellingPlans: "[data-selling-plan-selector]",
      sellingPlansWrapper: "[data-selling-plans-wrapper]",
      purchaseCards: "[data-purchase-cards]",
      cardDetails: "[data-card-details]",
      frequencySelector: "[data-frequency-selector]"
    };
    this.productBase = false;

    this.productSelector = this.closest(
      this.selectors.product
    ).querySelector("product-selector");

    if (!this.productSelector) {
      this.productSelector = this.closest(this.selectors.product);
      this.productBase = true;
    }

    this.productForm = this.closest(
      this.selectors.product
    ).querySelector("product-form");
  }

  connectedCallback() {
    this.setHandlers();
  }

  setHandlers() {
    this.querySelectorAll('input[name^="purchase_option_"]').forEach(
      radio => radio.addEventListener("change", this.onRadioChange.bind(this))
    );

    this.querySelectorAll(this.selectors.frequencySelector).forEach(
      select => select.addEventListener("change", this.onFrequencyChange.bind(this))
    );
  }

  onRadioChange(event) {
    const radio = event.target;
    const card = radio.closest(".purchase-card");

    this.querySelectorAll(".purchase-card").forEach(c =>
      c.classList.remove("purchase-card--selected")
    );
    card.classList.add("purchase-card--selected");

    if (radio.dataset.purchaseType === "one-time") {
      const groupSelect = this.querySelector(this.selectors.sellingPlanGroups);
      groupSelect.value = "one-time";

      this.querySelectorAll(this.selectors.sellingPlans).forEach(
        select => { select.value = ""; }
      );

      this.querySelectorAll(this.selectors.cardDetails).forEach(
        details => details.classList.add("is-hidden")
      );

      const sellingPlanInfo = this.closest('.product__purchase-options')
        .querySelector('.product__purchase--info');
      if (sellingPlanInfo) sellingPlanInfo.classList.add("hidden");

      this.updateProductSelector();
    } else {
      const groupId = radio.dataset.groupId;
      const firstPlanId = radio.dataset.firstPlanId;

      const groupSelect = this.querySelector(this.selectors.sellingPlanGroups);
      groupSelect.value = groupId;

      this.querySelectorAll(this.selectors.cardDetails).forEach(details => {
        details.classList.toggle("is-hidden", details.dataset.groupId !== groupId);
      });

      const frequencySelect = this.querySelector(
        `${this.selectors.frequencySelector}[data-group-id="${groupId}"]`
      );
      const planId = frequencySelect ? frequencySelect.value : firstPlanId;

      const hiddenWrapper = this.querySelector(
        `${this.selectors.sellingPlansWrapper} [data-id="Product-Purchase-Option-${groupId}"]`
      );
      if (hiddenWrapper) {
        const hiddenSelect = hiddenWrapper.querySelector(this.selectors.sellingPlans);
        if (hiddenSelect) hiddenSelect.value = planId;
      }

      const sellingPlanInfo = this.closest('.product__purchase-options')
        .querySelector('.product__purchase--info');
      if (sellingPlanInfo) sellingPlanInfo.classList.remove("hidden");

      this.updateProductSelector(planId);
    }
  }

  onFrequencyChange(event) {
    const select = event.target;
    const groupId = select.dataset.groupId;
    const planId = select.value;

    const hiddenWrapper = this.querySelector(
      `${this.selectors.sellingPlansWrapper} [data-id="Product-Purchase-Option-${groupId}"]`
    );
    if (hiddenWrapper) {
      const hiddenSelect = hiddenWrapper.querySelector(this.selectors.sellingPlans);
      if (hiddenSelect) hiddenSelect.value = planId;
    }

    this.updateProductSelector(planId);
  }

  isOneTimePurchase() {
    return (
      this.querySelector(this.selectors.sellingPlanGroups).value === "one-time"
    );
  }

  showError() {
    const activeDetails = this.querySelectorAll(
      `${this.selectors.cardDetails}:not(.is-hidden)`
    );
    activeDetails.forEach(detail => {
      const freqSelect = detail.querySelector(this.selectors.frequencySelector);
      if (freqSelect) {
        freqSelect.classList.add("has-error");
      } else {
        // Single-plan subscription (no frequency dropdown) — highlight the card itself
        const card = detail.closest(".purchase-card");
        if (card) card.classList.add("has-error");
      }
    });
  }

  updateProductSelector(sellingPlanId) {
    if (this.productBase) {
      this.updateProductBase(sellingPlanId);
      return;
    }

    if (!this.productSelector.currentVariant) {
      this.productSelector.updateVariant();
    }

    this.productSelector.updateURL(sellingPlanId);
    this.productSelector.renderProductInfo();
    if (
      this.productSelector.currentVariant.available &&
      sellingPlanId
    ) {
      this.productForm.setAttribute("data-has-selling-plan", "true");
      this.productForm.toggleAddButton(false, "");
      return;
    }

    this.productForm.removeAttribute("data-has-selling-plan");
    this.productForm.toggleAddButton(false, "");
  }

  updateProductBase(sellingPlanId) {
    const selectedVariant = this.productSelector.getSelectedVariant(
      this.productSelector
    );

    this.productSelector.updateSellingPlanURL(
      sellingPlanId,
      selectedVariant.id
    );
    this.renderPurchaseInfo(selectedVariant.id);

    if (selectedVariant.available && sellingPlanId) {
      this.productForm.setAttribute("data-has-selling-plan", "true");
      this.productForm.toggleSubmitButton(false, "");
      return;
    }

    this.productForm.removeAttribute("data-has-selling-plan");
    this.productForm.toggleSubmitButton(false, "");
  }

  renderPurchaseInfo(selectedVariantId) {
    const params = new URLSearchParams(window.location.search);
    params[params.has("variant") ? "set" : "append"](
      "variant",
      selectedVariantId
    );

    fetch(`${this.productSelector.dataset.url}?${params.toString()}`)
      .then(response => response.text())
      .then(responseText => {
        const html = new DOMParser().parseFromString(
          responseText,
          "text/html"
        );
        [
          `#Product-Purchase-Options-${this.productSelector.dataset.section}`,
          `#ProductPurchaseInfo-${this.productSelector.dataset.section}`
        ].map(
          liveRegionSelector => {
            const destination = document.querySelector(
              liveRegionSelector
            );
            const source = html.querySelector(liveRegionSelector);
            if (destination && source) {
              destination.classList.remove("hidden");
              // Safe: source is from same-origin Shopify section rendering, not user input
              destination.replaceChildren(...source.childNodes);
            }
          }
        );
      })
      .catch(error => {
        console.error(error);
      });
  }
}

customElements.define('purchase-options', PurchaseOptions);
